const e = (o) => `
    Incorrect usage of ${o} hook. 
    Correct Usage: 
    1. Use within PLMapbox children
    2. Use within Component wrapped with PLMapboxContainer
`;
export {
  e as storeHookErrorHelper
};
//# sourceMappingURL=index.es25.js.map
